import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2a55c9de"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "applicationsSubTitle" }, "Søknad", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Søknad-id:", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Søknadstype:", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Status:", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Endre status til usendt")

import { AuxButton, AuxCard } from '@ambita/design-system';
import APIServices from '@/services/apiFetch';

// eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  __name: 'WithdrawApplication',
  props: {
  applications: [],
  projectName: String,
},
  emits: ['setBanner'],
  setup(__props, { emit }) {

const props = __props


// eslint-disable-next-line no-undef


const withdrawApplication = async (application) => {
  const text = `Er du sikker på at du vill sette ${application.type.toLowerCase()}søknad: ${
    application.id
  }
   med referanse: ${application.reference} som tilhører prosjekt: ${props.projectName} til usendt?`;
  if (confirm(text)) {
    let response = await APIServices.putSubmissionStatus(application.id);
    emit('setBanner', response.status);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(AuxCard), { class: "applications" }, {
    default: _withCtx(() => [
      _hoisted_1,
      _hoisted_2,
      _createTextVNode(" " + _toDisplayString(props?.applications[0]?.id) + " ", 1),
      _hoisted_3,
      _hoisted_4,
      _createTextVNode(" " + _toDisplayString(props?.applications[0].type) + " ", 1),
      _hoisted_5,
      _hoisted_6,
      _createTextVNode(" " + _toDisplayString(props?.applications[0]?.status) + " ", 1),
      _hoisted_7,
      (props?.applications[0].reference)
        ? (_openBlock(), _createElementBlock("strong", _hoisted_8, "Referanse:"))
        : _createCommentVNode("", true),
      _createTextVNode(" " + _toDisplayString(props?.applications[0].reference) + " ", 1),
      (props?.applications[0]?.sent)
        ? (_openBlock(), _createBlock(_unref(AuxButton), {
            key: 1,
            primary: true,
            size: "small",
            class: "statusBtn",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (withdrawApplication(props?.applications[0])))
          }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})